import { render, staticRenderFns } from "./FreightAppraiseSetting.vue?vue&type=template&id=41b5cbf4&scoped=true"
import script from "./FreightAppraiseSetting.vue?vue&type=script&lang=js"
export * from "./FreightAppraiseSetting.vue?vue&type=script&lang=js"
import style0 from "./FreightAppraiseSetting.vue?vue&type=style&index=0&id=41b5cbf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b5cbf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b5cbf4')) {
      api.createRecord('41b5cbf4', component.options)
    } else {
      api.reload('41b5cbf4', component.options)
    }
    module.hot.accept("./FreightAppraiseSetting.vue?vue&type=template&id=41b5cbf4&scoped=true", function () {
      api.rerender('41b5cbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/DeliveryOrder/FreightAppraiseSetting.vue"
export default component.exports